import React from 'react';

export const AWAITING_TEAM_MESSAGE =
  'Our team will add the ingredients within 72 h. Pick another product to compare now.';

/** The solo scan: nothing to compare, the user waits for the analysis. */
export const AWAITING_TEAM_SOLO_MESSAGE =
  "Our team will add the ingredients within 72 h. We'll let you know when your analysis is ready. If we can't, your credit comes back.";

/** A side whose label went to the team: it cannot be compared (or analysed) yet. */
export default function AwaitingTeamCard({ onPickAnother, solo = false }: { onPickAnother: () => void; solo?: boolean }) {
  return (
    <div className="card card--sand card--compact stack-3" data-testid="awaiting-team">
      <p className="t-small" style={{ margin: 0 }}>{solo ? AWAITING_TEAM_SOLO_MESSAGE : AWAITING_TEAM_MESSAGE}</p>
      <button type="button" className="btn btn--ghost btn--sm justify-center" onClick={onPickAnother}>
        {solo ? 'Scan another product' : 'Pick another product'}
      </button>
    </div>
  );
}
